<template>
    <div style="overflow-x: hidden; overflow-y: auto; height: 100%">
        <div class="page_header">
            <span class="page_title">{{ $t('maintenanceReminder.维保提醒') }}</span>
            <el-form :inline="true" :model="searchForm" size="small" style="flex:1; text-align: right">
                <el-form-item :label="$t('maintenanceReminder.车型')">
                    <el-input v-model="searchForm.VehicleModel" :placeholder="$t('maintenanceReminder.请输入车型')"
                        clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('maintenanceReminder.阅读状态')">
                    <el-select v-model="searchForm.IsRead" :placeholder="$t('maintenanceReminder.请选择阅读状态')">
                        <el-option :label="$t('maintenanceReminder.全部')" value="-1"></el-option>
                        <el-option :label="$t('maintenanceReminder.已阅')" value="1"></el-option>
                        <el-option :label="$t('maintenanceReminder.未阅')" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" plain @click="goResetRecord">{{ $t('maintenanceReminder.维保重置记录') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>

        <!-- 维保统计图表卡片 -->
        <div class="stats-cards">
            <div class="stat-card">
                <div class="stat-card-title">{{ $t('maintenanceReminder.维保零部件提醒频次') }}</div>
                <div ref="partsChart" class="stat-chart"></div>
            </div>
            <div class="stat-card">
                <div class="stat-card-title">{{ $t('maintenanceReminder.各车辆维保项数') }}</div>
                <div ref="vehicleChart" class="stat-chart"></div>
            </div>
            <div class="stat-card">
                <div class="stat-card-title">{{ $t('maintenanceReminder.里程预警进度') }}</div>
                <div ref="mileageChart" class="stat-chart"></div>
            </div>
        </div>

        <div class="page_container">
            <el-table :data="tableData" v-loading="loading" stripe style="width: 100%">
                <el-table-column type="index" :label="$t('public.index')" align="center" width="60"></el-table-column>
                <el-table-column prop="CarNo" align="center" :label="$t('maintenanceReminder.车牌号')" min-width="120"></el-table-column>
                <el-table-column prop="VehicleModel" align="center" :label="$t('maintenanceReminder.车型')" min-width="120"></el-table-column>
                <el-table-column prop="EMileage" align="center" :label="$t('maintenanceReminder.currentMileage')" min-width="120">
                    <template slot-scope="scope">{{ scope.row.EMileage }} {{ $t('maintenanceReminder.km') }}</template>
                </el-table-column>
                <el-table-column align="center" :label="$t('maintenanceReminder.维保零部件')" min-width="180">
                    <template slot-scope="scope">{{ scope.row.Parts }}</template>
                </el-table-column>
                <el-table-column prop="Marker" align="center" :label="$t('maintenanceReminder.提醒里程')" min-width="120">
                    <template slot-scope="scope">{{ scope.row.Marker }} {{ $t('maintenanceReminder.km') }}</template>
                </el-table-column>
                <!-- 提醒时间：仅当维保零部件 ID 中包含 13 时才显示 -->
                <el-table-column align="center" :label="$t('maintenanceReminder.提醒时间')" min-width="120">
                    <template slot-scope="scope">
                        <span v-if="shouldShowReminderTime(scope.row)">{{ formatDate(scope.row.UpdateTime) }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="IsRead" align="center" :label="$t('maintenanceReminder.阅读状态')" min-width="110">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsRead === 1 ? 'success' : 'warning'" size="small">
                            {{ scope.row.IsRead === 1 ? $t('maintenanceReminder.已阅') : $t('maintenanceReminder.未阅') }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('public.Operation')" min-width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toggleRead(scope.row)">
                            {{ scope.row.IsRead === 1 ? $t('maintenanceReminder.设为未读') : $t('maintenanceReminder.设为已读') }}
                        </el-button>
                        <el-button type="text" size="small" @click="handleReset(scope.row)">
                            {{ $t('maintenanceReminder.重置') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <kl-pagination style="margin-bottom: 10px" :pageSize="PageSize" :total="total" @current-change="pageChange"
                :current-page.sync="PageNo" @size-change="sizeChange"></kl-pagination>
        </div>

        <!-- 重置维保提醒周期弹窗：确认后自动新增一条维保重置记录 -->
        <ResetRecordDialog :visible.sync="resetDialogVisible" :record="{ }" :prefill="resetPrefill"
            @submit="handleResetSubmit" />
    </div>
</template>

<script>
import { queryReminder, addResetRecord, updateReminderRead } from './mockData'
import ResetRecordDialog from './ResetRecordDialog.vue'

export default {
    name: 'MaintenanceReminder',
    components: { ResetRecordDialog },
    data() {
        return {
            searchForm: {
                VehicleModel: '',
                IsRead: '-1'
            },
            tableData: [],
            loading: false,
            PageNo: 1,
            PageSize: 10,
            total: 0,
            resetDialogVisible: false,
            resetPrefill: {},
            // 图表实例
            charts: { parts: null, vehicle: null, mileage: null },
            // 全量记录（用于图表统计）
            allRecords: []
        }
    },
    mounted() {
        this.loadData()
        this.loadChartData()
        window.addEventListener('resize', this.handleChartResize)
    },
    activated() {
        this.$nextTick(() => {
            Object.values(this.charts).forEach(c => c && c.resize())
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleChartResize)
        Object.values(this.charts).forEach(c => c && c.dispose())
    },
    methods: {
        // 提醒时间仅显示年月日
        formatDate(time) {
            if (!time) return ''
            return String(time).replace('T', ' ').replace('Z', '').split(' ')[0]
        },
        // 逻辑：当零部件 ID 中包含 13 时展示提醒时间
        shouldShowReminderTime(row) {
            const ids = row.PartIds || []
            return ids.some(id => String(id).indexOf('13') !== -1)
        },
        handleSearch() {
            this.PageNo = 1
            this.loadData()
            this.loadChartData()
        },
        sizeChange(size) {
            this.PageSize = size
            this.loadData()
        },
        pageChange(page) {
            this.PageNo = page
            this.loadData()
        },
        loadData() {
            this.loading = true
            queryReminder({
                VehicleModel: this.searchForm.VehicleModel,
                IsRead: this.searchForm.IsRead,
                PageNo: this.PageNo,
                PageSize: this.PageSize
            }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data || []
                    this.total = res.count || 0
                }
            })
        },
        // 切换阅读状态（已读 <-> 未读）
        toggleRead(row) {
            const next = row.IsRead === 1 ? 0 : 1
            updateReminderRead(row.RecordID, next).then(res => {
                if (res.code === 200) {
                    this.$message.success(this.$t('maintenanceReminder.阅读状态修改成功'))
                    this.loadData()
                    this.loadChartData()
                }
            })
        },
        // 打开重置弹窗，带入该车辆的维保信息
        handleReset(row) {
            this.resetPrefill = {
                CarNo: row.CarNo,
                ResetMileage: row.EMileage,
                ResetParts: row.Parts
            }
            this.resetDialogVisible = true
        },
        // 重置确认：自动新增一条维保重置记录
        handleResetSubmit(form) {
            addResetRecord(form).then(res => {
                if (res.code === 200) {
                    this.resetDialogVisible = false
                    this.$message.success(this.$t('maintenanceReminder.重置操作成功'))
                }
            })
        },
        // 加载全量数据用于图表统计
        loadChartData() {
            queryReminder({
                VehicleModel: this.searchForm.VehicleModel,
                IsRead: this.searchForm.IsRead,
                PageNo: 1,
                PageSize: 999
            }).then(res => {
                if (res.code === 200) {
                    this.allRecords = res.data || []
                    this.$nextTick(() => this.initCharts())
                }
            })
        },
        // 初始化三个图表
        initCharts() {
            const refs = [
                { ref: 'partsChart', key: 'parts' },
                { ref: 'vehicleChart', key: 'vehicle' },
                { ref: 'mileageChart', key: 'mileage' }
            ]
            refs.forEach(({ ref, key }) => {
                const dom = this.$refs[ref]
                if (!dom || dom.offsetWidth === 0) return
                if (this.charts[key]) this.charts[key].dispose()
                this.charts[key] = echarts.init(dom)
            })
            this.renderPartsChart()
            this.renderVehicleChart()
            this.renderMileageChart()
        },
        // 图表1：维保零部件提醒频次（环形图）
        renderPartsChart() {
            if (!this.charts.parts) return
            // 统计各零部件出现次数
            const partCount = {}
            this.allRecords.forEach(r => {
                const parts = (r.Parts || '').split(/[,，]+/).filter(Boolean)
                parts.forEach(p => { partCount[p] = (partCount[p] || 0) + 1 })
            })
            // 排序取 Top4 + 其他
            const sorted = Object.entries(partCount).sort((a, b) => b[1] - a[1])
            const top4 = sorted.slice(0, 4)
            const otherCount = sorted.slice(4).reduce((s, [, c]) => s + c, 0)
            const chartData = top4.map(([name, value]) => ({ name, value }))
            if (otherCount > 0) {
                chartData.push({ name: this.$t('maintenanceReminder.其他'), value: otherCount })
            }
            const total = chartData.reduce((s, i) => s + i.value, 0)
            const colors = ['#3C2ECA', '#A9AEFF', '#6F6FFF', '#22A5F7', '#D3D4DA']
            this.charts.parts.setOption({
                tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
                series: [
                    {
                        type: 'pie', radius: ['45%', '70%'], center: ['50%', '50%'],
                        data: chartData, color: colors,
                        label: { show: false }, labelLine: { show: false },
                        emphasis: { disabled: true }
                    },
                    {
                        type: 'pie', radius: '0%', center: ['50%', '50%'],
                        label: {
                            show: true, position: 'center',
                            formatter: () => `{n|${total}}\n{u|${this.$t('maintenanceReminder.总提醒')}}`,
                            rich: {
                                n: { fontSize: 20, fontWeight: 'bold', color: '#0E193B', lineHeight: 28 },
                                u: { fontSize: 12, color: '#999', lineHeight: 18 }
                            }
                        },
                        data: [{ value: 0 }]
                    }
                ]
            }, true)
        },
        // 图表3：各车辆维保项数（柱状图）
        renderVehicleChart() {
            if (!this.charts.vehicle) return
            const data = this.allRecords.map(r => ({
                name: r.CarNo,
                value: (r.Parts || '').split(/[,，]+/).filter(Boolean).length
            }))
            // 按维保项数着色：3项以上深色、2项中色、1项浅色
            const colors = data.map(d => {
                if (d.value >= 3) return '#3C2ECA'
                if (d.value >= 2) return '#A9AEFF'
                return '#6F6FFF'
            })
            this.charts.vehicle.setOption({
                tooltip: {
                    trigger: 'axis',
                    formatter: p => `${p[0].name}<br/>${this.$t('maintenanceReminder.维保项数')}: ${p[0].value}`
                },
                grid: { left: '3%', right: '5%', bottom: '15%', top: '10%', containLabel: true },
                xAxis: {
                    type: 'category', data: data.map(d => d.name),
                    axisLabel: {
                        color: '#666', interval: 0, rotate: 30,
                        formatter: v => v.length > 5 ? v.slice(0, 5) + '..' : v
                    },
                    axisTick: { show: false }, axisLine: { lineStyle: { color: '#eee' } }
                },
                yAxis: {
                    type: 'value', minInterval: 1,
                    axisLabel: { color: '#666' },
                    splitLine: { lineStyle: { color: '#f0f0f0' } }
                },
                series: [{
                    type: 'bar', barWidth: '50%',
                    data: data.map((d, i) => ({
                        value: d.value,
                        itemStyle: { color: colors[i], borderRadius: [4, 4, 0, 0] }
                    })),
                    label: { show: true, position: 'top', color: '#333', fontSize: 11 }
                }]
            }, true)
        },
        // 图表4：里程预警进度（横向条形图）
        renderMileageChart() {
            if (!this.charts.mileage) return
            const data = this.allRecords.map(r => {
                const pct = r.Marker > 0 ? (r.EMileage / r.Marker * 100) : 0
                return { name: r.CarNo, value: Math.round(pct * 10) / 10, raw: r }
            })
            // 按紧急度着色：>99% 橙色、97-99% 紫色、<97% 深紫
            const colors = data.map(d => {
                if (d.value > 99) return '#EFAA17'
                if (d.value >= 97) return '#6F6FFF'
                return '#3C2ECA'
            })
            this.charts.mileage.setOption({
                tooltip: {
                    trigger: 'axis', axisPointer: { type: 'shadow' },
                    formatter: p => {
                        const d = data[p[0].dataIndex]
                        return `${d.name}<br/>${this.$t('maintenanceReminder.里程进度')}: ${d.value}%<br/>${d.raw.EMileage} / ${d.raw.Marker} km`
                    }
                },
                grid: { left: '3%', right: '10%', bottom: '3%', top: '5%', containLabel: true },
                xAxis: {
                    type: 'value', max: 100,
                    axisLabel: { color: '#666', formatter: '{value}%' },
                    splitLine: { lineStyle: { color: '#f0f0f0' } }
                },
                yAxis: {
                    type: 'category', data: data.map(d => d.name), inverse: true,
                    axisLabel: {
                        color: '#666',
                        formatter: v => v.length > 6 ? v.slice(0, 6) + '..' : v
                    },
                    axisTick: { show: false }, axisLine: { lineStyle: { color: '#eee' } }
                },
                series: [{
                    type: 'bar', barWidth: '50%',
                    data: data.map((d, i) => ({
                        value: d.value,
                        itemStyle: { color: colors[i], borderRadius: [0, 4, 4, 0] }
                    })),
                    label: { show: true, position: 'right', formatter: '{c}%', color: '#333', fontSize: 11 }
                }]
            }, true)
        },
        // 窗口大小变化时重绘图表
        handleChartResize() {
            Object.values(this.charts).forEach(c => c && c.resize())
        },
        goResetRecord() {
            this.$router.push('/maintenance/resetRecord')
        }
    }
}
</script>

<style scoped>
.stats-cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
    padding: 0 20px 12px;
}
.stat-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
}
.stat-card-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 8px;
}
.stat-chart {
    width: 100%;
    height: 200px;
}
</style>